<template>
    <div>
        <LVector ref="olVector" :zIndex="10" :defaultStyle="defaultStyle" @selectFeature="handleSelectFeature">
            <ElementDataLayer :ref="item.id" v-for="item in hzList" :key="item.id" :layerData="item" :activityObj="activityObj"
                @getMapObj="getMapObj"></ElementDataLayer>
        </LVector>
        <!-- 事件点 -->
        <EventPoints ref="EventPoints" v-if="eventList && eventList.length > 0" :eventList="eventList"
            @getMapObj="getMapObj"></EventPoints>
        <!-- 照片点 -->
        <MapPhoto :photoList="photoList"></MapPhoto>
    </div>
</template>
<script>
import { DoubleClickZoom, MouseWheelZoom, PinchZoom, DragPan } from 'ol/interaction';

import { OMapMixin, LVector } from '@OpenLayersCommon';
import MapPhoto from '@/page/business/components/mapPhoto/index.vue';
import EventPoints from '@/page/mainPage/mapComponents/EventPoints.vue';
import ElementDataLayer from '@/page/business/components/mapLayer/elementDataLayer.vue';

export default {
    mixins: [OMapMixin],
    components: {
        LVector,
        ElementDataLayer,
        MapPhoto,
        EventPoints,
    },
    props: {

        eventList: {
            type: Array,
            default: () => [],
        },

        hzList: {
            type: Array,
            default: () => [],
        },

        // 照片列表
        photoList: {
            type: Array,
            default: () => ([]),
        },

        positionFitVal: {
            type: Array,
            default: () => [],
        },

    },

    data () {
        return {
            defaultStyle: {
                fill: {
                    color: '#49f0fd',
                },
                stroke: {
                    color: '#49f0fd',
                    width: 6,
                },
            },
            // 事件详情
            eventObj: {},
            activityObj: {},
        };
    },

    watch: {
        positionFitVal: {
            handler (val) {
                this.getCenterView(val);
            },
            deep: true,
        },

        hzList: {
            handler (newVal) {
                // console.log('hzList ', newVal);
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {},
    methods: {
        handleSelectFeature (feature) {
            const values = feature.getProperties();
            let id = feature.getId();
            let refs = {};

            if (values.name === 'event') {
                refs = this.$refs[values.id];
                this.getRefs(refs); // 显示地图弹窗
            } else if (id) {
                refs = this.$refs[id];
                this.getRefs(refs);
            }
        },

        async init () {
            // 获取地图实例
            const map = await this.getMap();
            this.$map = map;
            let gridInfoShow = this.$props.gridId !== '';
            // 网格详情地图禁用交互事件
            gridInfoShow && this.setMapDisable();
        },
        // 地图转到屏幕中央
        getCenterView (center) {
            this.$map && this.$map.getView().fit(center, {
                padding: [50, 50, 50, 50], // 四周留白 50px，避免边缘贴紧
                maxZoom: 16, // 最大缩放级别（可选，防止过度放大）
                duration: 1000, // 动画过渡时间（毫秒，可选）
            });
        },
        // 禁用地图交互
        async setMapDisable () {
            if (!this.$map) return;

            // 获取地图的缩放交互
            const zoomInteractions = this.$map
                .getInteractions()
                .getArray()
                .filter(
                    (interaction) =>
                        interaction instanceof PinchZoom
                        || interaction instanceof MouseWheelZoom
                        || interaction instanceof DoubleClickZoom
                        || interaction instanceof DragPan,
                );

            // 禁用所有缩放交互
            // zoomInteractions.forEach((interaction) => interaction.setActive(false));
        },
        // 显示地图弹窗
        getRefs (refs) {
            let refEl = null;
            if (Array.isArray(refs)) {
                refEl = refs[0];
            } else {
                refEl = refs;
            }
            if (refEl) {
                this.activityObj = refEl.layerData;
                refEl.showPopover();
            }
        },

        getMapObj (val, type) {
            if (type === 'event') {
                this.$refs.EventPoints.showPopover(val);
            } else {
                this.$refs[val.id].showImgPopover(val);
            }
        },

    },

    mounted () {
        this.init();
    },
};
</script>

<style lang="scss" scoped></style>
